module.exports = __webpack_public_path__ + "img/route_sender_letter_2.4182cb50.png";